// Deep link /<slug>: o picker global (OperationalModulePickerProvider) detecta o
// pathname e abre o modal. Esta rota não renderiza conteúdo próprio — evita
// “refresh” da área principal ao clicar na sidebar (o clique abre o modal in-place).
export const OperationalModuleEntryPage = () => null;
